import {
  ITimelineItem,
  ITimelineItemBase,
} from "../../../../components/shared/TimelineCalendar/timeline.types";
import { Flex, StyledTd, StyledTh, StyledTr } from "../../../../styled";
import { useController, useFormContext } from "react-hook-form";
import VitalsInputRow from "./VitalsInputRow";
import { Button, Text } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import VitalsInputWrapper from "./VitalsInputWrapper";
import { Fragment, useMemo } from "react";
import VitalsInputList from "./VitalsInputList";
import { v4 } from "uuid";
import VitalsInputRenderer from "./VitalsInputRenderer";
interface Props {
  id: string;
  value: ITimelineItemBase[] | undefined;
  unit: string;
  suffix?: string;
  disabled?: boolean;
}
const parser = (value: ITimelineItemBase[] | undefined) =>
  !value
    ? []
    : value.map((item: any) => ({
        ...item,
        id: v4(),
      }));

const VitalsInput = ({ id, value, unit, suffix, disabled }: Props) => {
  const {
    field: { onChange, value: items },
  } = useController({
    name: id,
    defaultValue: parser(value),
    disabled,
  });

  const handleChange = (updatedItems: ITimelineItemBase[]) => {
    const allItems = [...items];
    updatedItems.forEach((item: ITimelineItemBase, i) => {
      const matchedOldItemIndex = allItems.findIndex(el => el.id === item.id);
      if (matchedOldItemIndex !== -1) {
        allItems[matchedOldItemIndex] = item;
      } else {
        allItems.push(item);
      }
    });
    onChange(allItems);
  };
  const handleDeleteItems = (ids: string[] | string) => {
    const idsToDelete = typeof ids === "string" ? [ids] : ids;
    const newItems = items.filter(
      (item: ITimelineItemBase) => !idsToDelete.includes(item.id),
    );
    onChange(newItems);
  };
  return (
    <VitalsInputRenderer
      unit={unit}
      suffix={suffix}
      items={items}
      handleChange={handleChange}
      handleDeleteItems={handleDeleteItems}
    />
  );
};
export default VitalsInput;
